// extracted by mini-css-extract-plugin
export var bodyTitle = "index-module--bodyTitle--c8f2e";
export var box = "index-module--box--2986b";
export var textBlocks = "index-module--textBlocks--747b7";